import Vue from 'vue'
import Axios from 'axios'
import router from '@/router'
import store from '@/store'
import { displayErrors } from '@/utils/helpers'

Axios.defaults.baseURL = process.env.VUE_APP_BASE + 'api/'

Axios.interceptors.request.use(config => {
  store.dispatch('loading')
  config.headers.common.Tenant = 'BackOffice'
  config.headers.common.language = process.env.VUE_APP_APIHEADER_LOCALE
  if (localStorage.getItem('token')) {
    config.headers.common.Authorization =
      'Bearer ' + localStorage.getItem('token')
  }
  return config
})

Axios.interceptors.response.use(
  response => {
    store.dispatch('loaded')
    return response
  },
  async error => {
    store.dispatch('loaded')
    if (error.response) {
      if (error.response.status === 400) {
        if (error.response.data.ShouldBeShown) {
          displayErrors(error.response.data.Title)
        }
      }
      if (error.response.status === 401) {
        store.dispatch('logout')
        // router.push({
        //   path: '/login'
        // })
      }
      if (error.response.status === 403) {
        if (this.$store.getters.isLoggedIn) {
          router.push({
            path: '/forbidden'
          })
        }
      }
      if (error.response.status === 404) {
        router.push({
          path: '/notfound'
        })
      }
    } else {
      // displayInfo('Brak połączenia z serwerem')
    }
    return Promise.reject(error)
  }
)

Vue.$http = Axios

Object.defineProperty(Vue.prototype, '$http', {
  get () {
    return Axios
  }
})

export default {
  async get (endpoint, config = { snack: true }) {
    return await Vue.$http.get(`${endpoint}`)
  },
  async getById (endpoint, id) {
    return await Vue.$http.get(`${endpoint}/${id}`)
  },
  async put (endpoint, data = {}) {
    return await Vue.$http.put(`${endpoint}`, data)
  },
  async post (endpoint, data = {}) {
    return await Vue.$http.post(`${endpoint}`, data)
  },
  async delete (endpoint, id) {
    return await Vue.$http.delete(`${endpoint}/${id}`)
  },
  // getFile (endpoint, id) {
  //   return Vue.$http.get(`${endpoint}/${id}`, {
  //     responseType: 'blob'
  //   })
  // },
  async getFile (endpoint) {
    try {
      const response = await Vue.$http.get(`${endpoint}`, {
        responseType: 'blob'
      })
      return response
    } catch (error) {
      if (error.response.status === 400) {
        const errorString = JSON.parse(await error.response.data.text())
        if (errorString.ShouldBeShown) {
          displayErrors(errorString.Title)
        }
      }
      throw error
    }
  },
  postFile (endpoint, type, id, data) {
    return Vue.$http.post(`${endpoint}/${type}/${id}`, data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }
}
